import React from 'react'
import { Text } from 'app/components/ui/Text'
import styled, { css } from 'styled-components'
import { StepState } from '.'

interface StepNavsItemProps {
  index: number
  label: string
  state: StepState
}

export const StepsNavItem: React.FC<StepNavsItemProps> = ({
  index,
  label,
  state,
}) => {
  return (
    <StepsNavItemWrapper>
      <StepIndicator stepState={state}>
        <Text variant='s48' weight='700'>
          {index}
        </Text>
      </StepIndicator>
      <Text mt={1} variant='s20'>
        {label}
      </Text>
    </StepsNavItemWrapper>
  )
}

interface StepIndicatorProps {
  stepState: StepState
}

const getIndicatorVariant = ({ stepState }: StepIndicatorProps) => {
  switch (stepState) {
    case 'active':
      return css`
        color: white;
        background-color: ${({ theme }) => theme.color.primari.viola};
      `

    case 'future':
      return css`
        color: ${({ theme }) => theme.color.neutri.grigio};
        background-color: ${({ theme }) => theme.color.neutri.grigioChiaro};

        & + div {
          color: ${({ theme }) => theme.color.neutri.grigio};
        }
      `

    case 'past':
      return css`
        color: white;
        background: linear-gradient(358.5deg, #83d200 -20.46%, #00b0ff 91.8%);

        & + div {
          color: ${({ theme }) => theme.color.neutri.grigio};
        }
      `
  }
}

const StepsNavItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;
`

const StepIndicator = styled.div<StepIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 76px;
  height: 76px;

  border-radius: 20rem;
  ${getIndicatorVariant};
`
